export const isEmptyValue = (value?: string | number | boolean) => {
  return value === null || (typeof value === 'string' && value.trim().length === 0) || value === undefined;
};
